module.exports = __webpack_public_path__ + "assets/img/11.075a1762.jpg";